<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('preferences')">Filtro</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Criar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <!--            <ul class="pr-6 pb-8 w-full">-->
            <!--              <li v-for="(value, name) in filters" style="height: 35px">-->
            <!--                <b>{{ name }}:</b> {{ value }}-->
            <!--              </li>-->
            <!--            </ul>-->
            <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full" label="Nome" />
            <textarea-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full " label="Descrição" />
            <label class="mt-6 select-none flex items-center" for="favorite">
              <input id="favorite" v-model="form.favorite" class="mr-1" type="checkbox" />
              <span class="text-sm">Favorito?</span>
            </label>
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Criar Filtro & Listar</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  props: {
    preferences: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.preference.name,
        description: this.preference.description,
        favorite: this.preference.favorite,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('preferences.update', this.contact.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this preference?')) {
        this.$inertia.delete(this.route('preferences.destroy', this.contact.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this preference?')) {
        this.$inertia.put(this.route('preferences.restore', this.contact.id))
      }
    },
  },
}
</script>
